import {
	Center,
	Flex,
	Group,
	ScrollArea,
	Space,
	Table,
	Text,
} from '@mantine/core';
import type { ReactNode } from 'react';
import type { UseQueryResult } from 'react-query';
import { LoadingRows } from '../../../components/LoadingRows';
import { SearchField } from '../../../components/SearchField';
import { Title } from '../../../components/Title';
import type { ApiResponse } from '../../../util/types/Response';
import type { PromotionProductDto } from '../types/PromotionDto';
import { KeyedRow } from '../../../components/KeyedRow';

interface ProductListProps {
	searchQuery: string;
	setSearchQuery: (value: string) => void;
	records: ReactNode;
	productsQuery: UseQueryResult<ApiResponse<PromotionProductDto[]>, unknown>;
	filterContent?: ReactNode;
	height?: string;
	emptyPlaceholder: string;
	showEmptyMessage: boolean;
}

export function ProductsList({
	searchQuery,
	setSearchQuery,
	records,
	productsQuery,
	filterContent,
	emptyPlaceholder,
	showEmptyMessage,
	height = '22vh',
}: ProductListProps) {
	return (
		<>
			<Group justify={'space-between'}>
				<SearchField
					placeholder={'Search by description or SKUID...'}
					onDelayComplete={(value) => setSearchQuery(value)}
				/>
				<Flex justify={'flex-end'}>{filterContent}</Flex>
			</Group>
			<Space h={10} />
			<ScrollArea h={height}>
				<Table
					stickyHeader
					withRowBorders={!productsQuery.isLoading}
					striped={
						!productsQuery.isLoading &&
						productsQuery.data &&
						productsQuery.data?.value.length > 1
					}
					bg={'white'}
				>
					<Table.Thead>
						<KeyedRow>
							<Table.Th>
								<Title label={'SKUID'} />
							</Table.Th>
							<Table.Th>
								<Title label={'Description'} />
							</Table.Th>
							<Table.Th />
						</KeyedRow>
					</Table.Thead>
					<Table.Tbody>{records}</Table.Tbody>
					{productsQuery.isLoading && <LoadingRows columnSpan={200} rows={5} />}
				</Table>
				{showEmptyMessage && (
					<>
						<Space h={20} />
						<Center w={'100%'}>
							<Text size="sm">{emptyPlaceholder}</Text>
						</Center>
					</>
				)}
			</ScrollArea>
		</>
	);
}
